export enum ProposalDbStatus {
    Initial = 0,
    InEstimation = 1,
    InValidation = 2,
    Sent = 3,
    Won = 9,
    Lost = 10,
    Abandoned = 11
}
